import React, { useState, useRef } from 'react';
import { bool } from 'prop-types';

import { Image } from '@thd-olt-component-react/image';
import { PromoSummary } from '../promo-summary/PromoSummary';
import { usePromoModel } from '../../contexts/PromoModelProvider';

import './PromoViewDetails.scss';

export const PromoViewDetails = ({ isInPromoDrawer }) => {
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const { analyticsComponent } = usePromoModel();
  const bmsmViewDetailsClicked = useRef(false);

  const openSummaryPage = () => {
    if (!bmsmViewDetailsClicked.current) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('promotion-products-summary-page.click', {
        component: analyticsComponent,
        section: 'promotion',
        target: 'tiers',
      });
      bmsmViewDetailsClicked.current = true;
    }
    setIsSummaryOpen(true);
  };

  return (
    <span className="promo-view-details">
      &nbsp;|&nbsp;
      <Image
        asset="info.svg"
        onClick={openSummaryPage}
        alt="Promotion Summary Page"
      />
      &nbsp;
      <button
        type="button"
        className="promo-view-details-button"
        onClick={openSummaryPage}
      >
        View Details
      </button>
      <PromoSummary
        isSummaryOpen={isSummaryOpen}
        setIsSummaryOpen={setIsSummaryOpen}
        isInPromoDrawer={isInPromoDrawer}
      />
    </span>
  );
};

PromoViewDetails.displayName = 'PromoViewDetails';

PromoViewDetails.propTypes = {
  isInPromoDrawer: bool,
};

PromoViewDetails.defaultProps = {
  isInPromoDrawer: false,
};
